import * as React from 'react';
import rectIcon from '../../assets/images/rectangle-icon.svg';
import ellipseIcon from '../../assets/images/ellipse-icon.svg';

interface ICheckboxInputProps {
    name: string;
    label: string;
    icon?: string;
    onChange: (e: any) => void;
    checked?: boolean;
    disabled?: any;
    error?: any;
}

const CheckboxInputRaw = (props: ICheckboxInputProps) => {
    let wrapperClass = 'checkbox-raw checkbox-for-label';
    if (props.error && props.error.length > 0) {
        wrapperClass += ' has-error';
    }

    return (
        <span className={wrapperClass}>
            <input
                type="checkbox"
                id={props.name}
                name={props.name}
                className="form-control"
                checked={props.checked}
                disabled={props.disabled}
                onChange={props.onChange}
            />
            <label htmlFor={props.name}>
                {props.icon && props.icon !== 'rect' && props.icon !== 'ellipse' && (
                    <i className="material-icons">{props.icon}</i>
                )}
                {props.icon && props.icon === 'rect' && (
                    <img className="custom-icon" src={rectIcon} />
                )}
                {props.icon && props.icon === 'ellipse' && (
                    <img className="custom-icon" src={ellipseIcon} />
                )}
                {props.label}
            </label>
            {props.error && <div className="alert alert-danger">{props.error}</div>}
        </span>
    );
};

export default CheckboxInputRaw;
